import { all, fork } from 'redux-saga/effects';
import { registerUserSaga } from './register-user';
export function* rootSaga() {
    yield all([fork(registerUserSaga)]);
}
